









































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import { ToggleButton } from 'vue-js-toggle-button';
import SearchField from '@/components/SearchField.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import TagInput from '@/components/TagInput.vue';
import FormInput from '@/components/FormInput.vue';
import Loader from '@/components/Loader.vue';
import api from '@/libs/api';
import Select from '@/components/Select.vue';
import {
  MerchantsManagement,
  ProvinceList,
  CityList,
  DistrictList,
} from '@/libs/api.interfaces';

import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import Button from '@/components/Button.vue';
import numberFormat from '@/libs/numberFormat';
import { ValidationObserver } from 'vee-validate';

@Component({
  components: {
    ValidationObserver,
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    Loader,
    SearchField,
    TagInput,
    FormInput,
    Button,
    Select,
    ToggleButton,
  },
  methods: {
    numberFormat,
  },
})
export default class MerchantInformation extends Vue {
  loading = true;
  data!: MerchantsManagement;

  merchantDetailInformation: any[] = [];
  myDataVariable = false;
  merchantId = '';
  merchantName = '';
  secretKey = '';
  merchantManager = '';
  paymentUrl = '';
  singleIntegration = '';
  transNumber = '';

  merchantCode = '';
  brandName = '';
  bankBranch = '';
  phoneNumber = '';
  merchantLogo = '';
  merchantURLPage = '';
  postalCode = '';
  npwpAddress = '';
  address = '';
  merchantBrand = '';
  MCC = '';
  faxNumber = '';
  customerType = '';
  npwpNumber = '';
  bankName = '';
  picBusinessFullName = ''
  picBusinessEmail = '';
  picBusinessPhoneNumber = '';
  pictechnicalFullName = '';
  picTechnicalEmail = '';
  pictechnicalPhoneNumber = '';
  picFinanceFullName = ''
  picFinanceEmail = '';
  picFinancePhoneNumber = '';
  merchantPanelAccount = '';
  merchantPanelName = '';
  merchantPanelEmail = '';
  MerchantPanelPhoneNumber = '';
  notificationEmail: { value: string }[] = [];
  dailyReport: { value: string }[] = [];
  settlementReport: { value: string }[] = [];
  status = '';
  merchantNPWP = '';
  $refs!: {
    fileInput: HTMLInputElement;
    merchantSIUPinput: HTMLInputElement;
    merchantNPWPinput: HTMLInputElement;
    merchantTDPinput: HTMLInputElement;
    directorIdentityCardinput: HTMLInputElement;
    directorNPWPinput: HTMLInputElement;
  }

  merchantSIUP = '';
  merchantTDP = '';
  directorIdentityCard = '';
  directorNPWP = '';
  merchantLogoName = '';
  merchantNPWPName = '';
  merchantSIUPName = '';
  MerchantTDPName = '';
  directorIdentityCardName = '';
  directorNPWPName = '';
  url = process.env.VUE_APP_API_URL;
  country: { id: number; name: string } | null = null;
  countryList: { id: number; name: string }[] = [];
  province: { id: number; name: string } | null = null;
  provincelist: { id: number; name: string }[] = [];
  city: { id: number } | null = null;
  citylist: { id: number; name: string }[] = [];
  district: { id: number } | null = null;
  districtlist: { id: number; name: string }[] = [];

  loadingCountry = false;
  loadingProvince = false;
  loadingCity = false;
  loadingDistrict = false;

  mounted() {
    // console.log(this.$store.state.user.user);
    this.getData();
    //   this.getMerchant();
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */

  activeInactive() {
    console.log(this.myDataVariable);
  }

  async getData() {
    /* eslint-disable @typescript-eslint/camelcase */
    const userRole = this.$route.params.user_role;
    const userGroup = this.$route.params.user_group;
    const merchId = this.$route.params.merch_id;
    try {
      const data = await api.get('/onepay/merchants_detail', {
        params: {
          user_role: userRole,
          user_group: userGroup,
          merch_id: merchId,
        },
      });

      console.log('datamerchant', data.data);
      this.merchantDetailInformation = data.data.merchant;
      this.merchantId = data.data.merchant.merch_id;
      this.merchantName = data.data.merchant.merchant_name;
      this.merchantManager = data.data.merchant.refund_receiver;
      this.secretKey = data.data.merchant.secret_key;
      this.paymentUrl = data.data.merchant.use_ssl === '1'
        ? `https://${data.data.merchant.http_host}${data.data.merchant.payment_path}`
        : `http://${data.data.merchant.http_host}${data.data.merchant.payment_path}`;
      this.singleIntegration = data.data.merchant.single_integration_secret_key;
      this.transNumber = data.data.merchant.use_onepay_trx;
      this.myDataVariable = data.data.merchant.isActive === '1';
    } catch (err) {
      console.error(err);
    }
  }

  async onFileChange(e: any) {
    const file = e.target.files[0];
    const image = new FormData();
    image.append('image', file);
    this.merchantLogo = URL.createObjectURL(file);
    const { data } = await api.post('/upload', image);
    this.merchantLogoName = data;
  }

  async onNPWPChange(e: any) {
    const file = e.target.files[0];
    const image = new FormData();
    image.append('image', file);
    this.merchantNPWP = URL.createObjectURL(file);
    const { data } = await api.post('/upload', image);
    this.merchantNPWPName = data;
  }

  async onSIUPChange(e: any) {
    const file = e.target.files[0];
    const image = new FormData();
    image.append('image', file);
    this.merchantSIUP = URL.createObjectURL(file);
    const { data } = await api.post('/upload', image);
    this.merchantSIUPName = data;
  }

  async onTDPChange(e: any) {
    const file = e.target.files[0];
    const image = new FormData();
    image.append('image', file);
    this.merchantTDP = URL.createObjectURL(file);
    const { data } = await api.post('/upload', image);
    this.MerchantTDPName = data;
  }

  async directorIdentityCardChange(e: any) {
    const file = e.target.files[0];
    const image = new FormData();
    image.append('image', file);
    this.directorIdentityCard = URL.createObjectURL(file);
    const { data } = await api.post('/upload', image);
    this.directorIdentityCardName = data;
  }

  async directorNPWPChange(e: any) {
    const file = e.target.files[0];
    const image = new FormData();
    image.append('image', file);
    this.directorNPWP = URL.createObjectURL(file);
    const { data } = await api.post('/upload', image);
    this.directorNPWPName = data;
  }

  async getCountry() {
    try {
      this.loadingCountry = true;
      this.loading = false;
      const { data } = await api.get<ProvinceList[]>('/countries', {
        params: {
          id: 1,
        },
      });
      this.countryList = data.map((e: any) => ({
        id: e.id,
        name: e.name,
      }));
      if (!this.province) {
        this.country = this.countryList.find((e) => e.id === Number(this.data.country)) || null;
      } else {
        this.getProvince();
      }
      this.loadingCountry = false;
    } catch (err) {
      console.error(err);
    }
  }

  @Watch('country')
  async getProvince() {
    try {
      this.loadingProvince = true;
      this.loading = false;
      const { data } = await api.get<ProvinceList[]>('/countries', {
        params: {
          id: 1,
        },
      });
      this.provincelist = data[0].provinces.map((e: any) => ({
        id: e.id,
        name: e.name,
      }));
      if (!this.province) {
        this.province = this.provincelist.find((e) => e.id === this.data.province) || null;
      } else {
        this.getCity();
      }
      this.loadingProvince = false;
    } catch (err) {
      console.error(err);
    }
  }

  @Watch('province')
  async getCity() {
    if (this.province === null) return;
    try {
      this.loading = false;
      this.loadingCity = true;
      const { data } = await api.get<CityList[]>('/provinces', {
        params: {
          id: this.province.id,
        },
      });
      this.citylist = data[0].cities.map((e: any) => ({
        id: e.id,
        name: e.name,
      }));
      if (!this.city) {
        this.city = this.citylist.find((e) => e.id === Number(this.data.city)) || null;
      } else {
        this.getdistrict();
      }

      this.loadingCity = false;
    } catch (err) {
      console.error(err);
    }
  }

  @Watch('city')
  async getdistrict() {
    if (this.city === null) return;
    try {
      this.loading = false;
      this.loadingDistrict = true;
      const { data } = await api.get<DistrictList[]>('/cities', {
        params: {
          id: this.city.id,
        },
      });
      this.districtlist = data[0].districts.map((e: any) => ({
        id: e.id,
        name: e.name,
      }));
      if (!this.district) {
        this.district = this.districtlist.find((e) => e.id === Number(this.data.district)) || null;
      }
      this.loadingDistrict = false;
    } catch (err) {
      console.error(err);
    }
  }

  cancel() {
    this.$router.push('/onepay/onepaymerchant');
  }

  async editMerchant() {
    const userRole = this.$route.params.user_role;
    const userGroup = this.$route.params.user_group;
    const merchId = this.$route.params.merch_id;

    await api.post('/onepay/merchants_edit', {
      user_role: userRole,
      user_group: userGroup,
      merch_id: merchId,
      single_integration_secret_key: this.singleIntegration,
      payment_url: this.paymentUrl,
      refund_receiver: this.merchantManager,
      use_onepay_trx: this.transNumber,
      is_active: this.myDataVariable === true ? 'on' : 'off',
      merchant_name: this.merchantName,
    });

    this.getData();
    this.$router.go(0);
  }
}
